const countries = [
  { name: 'Nigeria', flag: '🇳🇬', region: 'Africa' },
  { name: 'Ghana', flag: '🇬🇭', region: 'Africa' },
  { name: 'Kenya', flag: '🇰🇪', region: 'Africa' },
  { name: 'South Africa', flag: '🇿🇦', region: 'Africa' },
  { name: 'Tanzania', flag: '🇹🇿', region: 'Africa' },
  { name: 'Ethiopia', flag: '🇪🇹', region: 'Africa' },
  { name: 'UAE', flag: '🇦🇪', region: 'Middle East' },
  { name: 'Saudi Arabia', flag: '🇸🇦', region: 'Middle East' },
  { name: 'Qatar', flag: '🇶🇦', region: 'Middle East' },
  { name: 'Oman', flag: '🇴🇲', region: 'Middle East' },
  { name: 'Philippines', flag: '🇵🇭', region: 'Asia' },
  { name: 'Vietnam', flag: '🇻🇳', region: 'Asia' },
  { name: 'Indonesia', flag: '🇮🇩', region: 'Asia' },
  { name: 'Bangladesh', flag: '🇧🇩', region: 'Asia' },
  { name: 'India', flag: '🇮🇳', region: 'Asia' },
  { name: 'Pakistan', flag: '🇵🇰', region: 'Asia' },
  { name: 'Australia', flag: '🇦🇺', region: 'Pacific' },
  { name: 'New Zealand', flag: '🇳🇿', region: 'Pacific' },
  { name: 'Brazil', flag: '🇧🇷', region: 'Americas' },
  { name: 'Mexico', flag: '🇲🇽', region: 'Americas' },
  { name: 'Colombia', flag: '🇨🇴', region: 'Americas' },
  { name: 'USA', flag: '🇺🇸', region: 'Americas' },
  { name: 'UK', flag: '🇬🇧', region: 'Europe' },
  { name: 'Germany', flag: '🇩🇪', region: 'Europe' },
];

const regionColors: Record<string, string> = {
  Africa: 'bg-orange-50 border-orange-200 text-orange-700',
  'Middle East': 'bg-yellow-50 border-yellow-200 text-yellow-700',
  Asia: 'bg-red-50 border-red-200 text-red-700',
  Pacific: 'bg-teal-50 border-teal-200 text-teal-700',
  Americas: 'bg-green-50 border-green-200 text-green-700',
  Europe: 'bg-gray-100 border-gray-200 text-gray-700',
};

export default function CountriesSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-[1420px] mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
          <div className="text-center md:text-left">
            <span className="text-xs font-black tracking-widest uppercase" style={{ color: '#0a2342' }}>Global Reach</span>
            <h2 className="text-3xl md:text-4xl font-black text-gray-900 mt-2 mb-2">We Ship to 50+ Countries</h2>
            <p className="text-gray-500 text-sm max-w-xl mx-auto md:mx-0">
              From West Africa to Southeast Asia, the Middle East to South America — Steelinkglobal delivers quality Chinese steel worldwide.
            </p>
          </div>
          <div className="flex flex-wrap gap-2 justify-center md:justify-end">
            {Object.entries(regionColors).map(([region, cls]) => (
              <span key={region} className={`px-3 py-1 rounded-full text-xs font-semibold border ${cls}`}>
                {region}
              </span>
            ))}
          </div>
        </div>

        {/* Country grid */}
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-3">
          {countries.map((c) => (
            <div
              key={c.name}
              className={`flex flex-col items-center gap-1.5 p-3 rounded-lg border text-center ${regionColors[c.region]}`}
            >
              <span className="text-2xl">{c.flag}</span>
              <span className="text-xs font-semibold leading-tight">{c.name}</span>
            </div>
          ))}
          {/* +More card */}
          <div className="flex flex-col items-center justify-center gap-1.5 p-3 rounded-lg border border-dashed border-gray-300 text-center bg-gray-50">
            <span className="text-2xl font-black text-gray-400">+26</span>
            <span className="text-xs font-semibold text-gray-400 leading-tight">More Countries</span>
          </div>
        </div>

        {/* Stats row */}
        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { val: '50+', label: 'Countries Served', icon: 'ri-global-line' },
            { val: '6', label: 'Continents Reached', icon: 'ri-earth-line' },
            { val: '5', label: 'Major Ports', icon: 'ri-ship-line' },
            { val: '500K+', label: 'MT Shipped Annually', icon: 'ri-stack-line' },
          ].map((s) => (
            <div key={s.label} className="flex items-center gap-4 p-4 bg-gray-50 rounded-xl border border-gray-100">
              <div className="w-12 h-12 flex items-center justify-center rounded-lg flex-shrink-0" style={{ backgroundColor: '#0a2342' }}>
                <i className={`${s.icon} text-white text-xl`} />
              </div>
              <div>
                <div className="text-2xl font-black text-gray-900">{s.val}</div>
                <div className="text-xs text-gray-500 font-medium">{s.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
